import React from 'react';
import { motion } from 'framer-motion';

// New page mounts instantly (Slider handles its own fade-in once images load).
// Old page stays fully visible for `exitDelay` seconds so the new page's images
// can appear on top of it before the old page is cleaned up from the DOM.
const pageVariants = {
    initial: { opacity: 1 },
    animate: { opacity: 1 },
    exit: {
        opacity: 0,
        transition: { delay: 2, duration: 0.3, ease: "easeInOut" }
    }
};

const PageTransition = ({ children, className }) => {
    return (
        <motion.div
            className={className}
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
            }}
        >
            {children}
        </motion.div>
    );
};

export default PageTransition;
